import { render, staticRenderFns } from "./SidebarSwitcherFilters.vue?vue&type=template&id=118f0cda&"
import script from "./SidebarSwitcherFilters.vue?vue&type=script&lang=js&"
export * from "./SidebarSwitcherFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports